<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    :submit-btn-name="submitBtnName"
    width="80%"
    @submit="submitForm"
    @close="$_resetFormAndValidation"
  >
    <v-form :ref="formRef">
      <v-text-field
        v-model.trim="form.name"
        :rules="validator.getRulesByField('name')"
        label="Name"
        @keypress.enter="submitForm"
      />

      <v-text-field
        v-model.trim="form.shortName"
        :rules="validator.getRulesByField('shortName')"
        label="Short Name"
        @keypress.enter="submitForm"
      />

      <v-layout class="mt-2">
        <v-flex
          class="pr-2"
          sm6
        >
          <strong>
            Azure Tenant Body
          </strong>

          <vbt-code
            v-model.trim="form.azureTenantBody"
            class="mt-3"
          />
        </v-flex>

        <v-flex
          class="pl-2"
          sm6
        >
          <strong>
            Azure App Tenant Body
          </strong>

          <vbt-code
            v-model.trim="form.azureAppTenantBody"
            class="mt-3"
          />
        </v-flex>
      </v-layout>
    </v-form>
  </vbt-dialog>
</template>

<script>
import { useDialog, useEditor, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import TenantsApiService from '../_services/tenants.api.service';

import { generateTenantModel } from '../_models/tenant.model';

const editorOptions = { formGenerator: generateTenantModel };

const validator = Validator.createValidator({
  name: ['required'],
  shortName: ['required'],
});

const prepareJSON = (str) => (str ? JSON.stringify(JSON.parse(str), null, '\t') : '');

export default {
  name: 'UmsTenantEditor',
  mixins: [
    useFormWithRef(),
    useEditor(editorOptions),
    Validator.useValidator(validator),
    useDialog({ openHandlerName: 'setForm' }),
  ],
  computed: {
    title() {
      return this.creator ? 'Create tenant' : `Edit ${this.item.name}`;
    },
    action() {
      return this.creator ? TenantsApiService.createTenant : TenantsApiService.updateTenant;
    },
    submitPromptText() {
      return this.creator ? 'Create tenant?' : `Update tenant ${this.item.name}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.$_validateForm()) {
        return;
      }

      this.$VBlackerTheme.alert.warning({
        text: this.submitPromptText,
      }, () => this.wrapToLoadingFn({
        req: this.action.bind({}, { name: this.item.name, data: this.form }),
        fullscreenLoadingSpinner: true,
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`Successfully ${
            this.creator ? 'created' : 'updated'
          }`);
          this.$emit('success');
          this.$_closeDialog();
        },
      }));
    },
    setForm() {
      Object.assign(this, {
        form: this.creator
          ? generateTenantModel()
          : {
            name: this.item.name,
            shortName: this.item.short_name,
            azureTenantBody: prepareJSON(this.item.azure_tenant_body),
            azureAppTenantBody: prepareJSON(this.item.azure_app_tenant_body),
          },
      });
      this.$_resetFormValidation();
    },
  },
};
</script>
